import { keyValuePair } from '../../models/keyValuePair';

export const Role = {
  ADMIN: 1,
  SUBADMIN: 2
};

export const UserRole = {
  BUYER: 1,
  SELLER: 2
};

export const CategoryType = {
  PROPERTIES: 1,
  COMPANIES: 2,
  ADVERTISERS: 3
};

export const CategoryArray: Array<keyValuePair> = [
  {
    key: 'Properties',
    value: 1
  },
  {
    key: 'Companies',
    value: 2
  },
  {
    key: 'Advertiser',
    value: 3
  }
];

export const CategoryTypeTexxt: any = {
  1: 'PROPERTIES',
  2: 'COMPANIES',
  3: 'ADVERTISERS'
};
